export const SALES_TEAM_POSITIONS = ['regional_manager', 'state_manager', 'sales'];
